import { AdditiveBlending, Sprite, SpriteMaterial } from 'three';
import type { Vector3 } from 'three';
import { drawnTexture } from '../arena/canvasTexture';

const seconds = 0.16;

/** The cartoon burst where a punch lands: a spiky white-gold star that pops out and fades in a blink. */
export class ImpactFlash {
  readonly sprite: Sprite;
  private readonly material: SpriteMaterial;
  private age = seconds;
  private size = 0;

  constructor() {
    const texture = drawnTexture(256, 256, (g, w, h) => {
      g.translate(w / 2, h / 2);
      const glow = g.createRadialGradient(0, 0, 0, 0, 0, w / 2);
      glow.addColorStop(0, 'rgba(255, 255, 240, 1)');
      glow.addColorStop(0.35, 'rgba(255, 220, 120, 0.9)');
      glow.addColorStop(1, 'rgba(255, 140, 20, 0)');
      g.fillStyle = glow;
      g.beginPath();
      const points = 12;
      for (let i = 0; i < points * 2; i++) {
        const r = i % 2 === 0 ? w * 0.5 : w * 0.2;
        const a = (i / (points * 2)) * Math.PI * 2;
        g.lineTo(Math.cos(a) * r, Math.sin(a) * r);
      }
      g.closePath();
      g.fill();
    });
    // It sits on top of whatever it is on, gloves included: the hit must read.
    this.material = new SpriteMaterial({ map: texture, transparent: true, depthTest: false, depthWrite: false, blending: AdditiveBlending, opacity: 0 });
    this.sprite = new Sprite(this.material);
    this.sprite.renderOrder = 20;
    this.sprite.visible = false;
  }

  /** A burst at this point, this wide in metres. */
  pop(at: Vector3, size: number): void {
    this.sprite.position.copy(at);
    this.material.rotation = Math.random() * Math.PI;
    this.size = size;
    this.age = 0;
  }

  update(elapsed: number): void {
    this.age += elapsed;
    const done = this.age / seconds;
    this.sprite.visible = done < 1;
    if (!this.sprite.visible) return;
    this.sprite.scale.setScalar(this.size * (0.55 + 0.6 * Math.sqrt(done)));
    this.material.opacity = 1.6 * (1 - done);
  }
}
